import React from 'react';
import { useTranslation } from 'react-i18next';
import { WHATSAPP } from '@/i18n';

// Simple WhatsApp glyph
const WaIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3.2c-7.1 0-12.86 5.76-12.86 12.86 0 2.27.6 4.48 1.73 6.43L3.2 28.8l6.5-1.7a12.8 12.8 0 0 0 6.34 1.62h.01c7.1 0 12.86-5.76 12.86-12.86 0-3.44-1.34-6.67-3.77-9.1a12.78 12.78 0 0 0-9.1-3.76zm0 23.3h-.01a10.66 10.66 0 0 1-5.43-1.49l-.39-.23-4.02 1.05 1.07-3.92-.25-.4a10.64 10.64 0 0 1-1.63-5.65c0-5.9 4.8-10.7 10.7-10.7 2.86 0 5.54 1.11 7.56 3.13a10.63 10.63 0 0 1 3.13 7.57c0 5.9-4.8 10.7-10.7 10.7zm5.87-8.01c-.32-.16-1.9-.94-2.2-1.05-.29-.11-.5-.16-.72.16-.21.32-.82 1.05-1.01 1.26-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.59-1.6-.96-.85-1.6-1.9-1.79-2.22-.19-.32-.02-.5.14-.66.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.38-.26-.62-.53-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.08 1.3 3.29.16.21 2.25 3.44 5.46 4.82.76.33 1.36.53 1.82.68.77.24 1.46.21 2.01.13.61-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export const WhatsAppFab = () => {
  const { t } = useTranslation();
  return (
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t('common.whatsapp')}
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-salvia text-textDark shadow-lg shadow-textDark/20 pl-4 pr-4 py-4 md:hover:pr-6 transition-[padding,transform] duration-300 hover:scale-[1.03]"
    >
      <WaIcon />
      <span className="hidden md:inline-block max-w-0 overflow-hidden whitespace-nowrap font-semibold group-hover:max-w-[220px] transition-[max-width] duration-500">
        {t('common.whatsapp')}
      </span>
    </a>
  );
};
